import useAuthStore from "@repo/core/stores/auth";
import { useMemo } from "react";

export const useUserPermissions = () => {
  const { user } = useAuthStore();

  const permissions = useMemo(() => user?.permissions ?? [], [user]);

  const hasPermission = (validatePermissions?: string[]) => {
    if (!validatePermissions) {
      return false;
    }

    return validatePermissions.some((permission) =>
      permissions.includes(permission)
    );
  };

  return { permissions, hasPermission };
};
